/* global department costcenter uncommittedExpendituresCreateUrl uncommittedExpendituresDetailsUrl uncommittedExpendituresStoreUrl committedExpendituresCreateUrl uncommittedExpenditureGroups vikEnabled */

import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import UncommittedExpendituresCreateInProgressList from './UncommittedExpendituresCreateInProgressList';
import UncommittedExpendituresCreateList from './UncommittedExpendituresCreateList';

export default function UncommittedExpendituresCreate() {
    return (
        <>
            <h5 className="text-blue font-weight-600 mb-2">
                {'Department: ' + department.name} {costcenter !== undefined ?? ' - Cost Center: ' + costcenter.name}
            </h5>
            <UncommittedExpendituresCreateList
                uncommittedExpendituresCreateUrl={uncommittedExpendituresCreateUrl}
                uncommittedExpendituresDetailsUrl={uncommittedExpendituresDetailsUrl}
                uncommittedExpendituresStoreUrl={uncommittedExpendituresStoreUrl}
                committedExpendituresCreateUrl={committedExpendituresCreateUrl}
                department={department}
                costcenter={costcenter}
                vikEnabled={vikEnabled}
            />
            <UncommittedExpendituresCreateInProgressList
                uncommittedExpenditureGroups={uncommittedExpenditureGroups}
                committedExpendituresCreateUrl={committedExpendituresCreateUrl}
            />
        </>
    );
}

if (document.getElementById('UncommittedExpendituresCreate')) {
    var rootEl = document.getElementById('UncommittedExpendituresCreate');
    ReactDOM.render(
        <App>
            <UncommittedExpendituresCreate />
        </App>,
        rootEl,
    );
}
